var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnOnDemand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 99.488,
    height: 99.171,
    viewBox: "0 0 99.488 99.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "circle",
    x: 0,
    y: 0,
    width: 99.488,
    height: 99.171,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.078
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-On-Demand",
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -6)",
    filter: "url(#circle)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "circle-2",
    "data-name": "circle",
    cx: 40.744,
    cy: 40.586,
    rx: 40.744,
    ry: 40.586,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dots",
    transform: "translate(9.236 5.722)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16132",
    "data-name": "Group 16132",
    transform: "translate(0 13.653)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1262",
    "data-name": "Ellipse 1262",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(13.539 51.341)",
    fill: "#e7e6e6"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1263",
    "data-name": "Ellipse 1263",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(4.832)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1264",
    "data-name": "Ellipse 1264",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(0 27.552)",
    fill: "#97d3f1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16131",
    "data-name": "Group 16131",
    transform: "translate(30.922)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1265",
    "data-name": "Ellipse 1265",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(18.824 63.153)",
    fill: "#8c94c9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1266",
    "data-name": "Ellipse 1266",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    transform: "translate(27.398 31.535)",
    fill: "#97d3f1"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1267",
    "data-name": "Ellipse 1267",
    cx: 1.16,
    cy: 1.155,
    rx: 1.16,
    ry: 1.155,
    fill: "#e7e6e6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19001",
    "data-name": "Group 19001",
    transform: "translate(16.715 19.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25523",
    "data-name": "Path 25523",
    d: "M10.518,5.955,10.243,5.5a19.371,19.371,0,0,1,27.042,0l-.26.429a.681.681,0,0,0,.091.175,19.064,19.064,0,0,1,5.438,10.611.681.681,0,0,0,.5.408.882.882,0,0,1,.955.936.917.917,0,0,0,.389.594,6.694,6.694,0,0,1,.028,11.47,1.053,1.053,0,0,0-.416.648c-.094.593-.344.928-.985.89-.307-.018-.616.009-.923,0-.339-.011-.647-.018-.815.379a.562.562,0,0,1-.4.3c-.654,0-.785.492-1.012.942a14.666,14.666,0,0,1-11.394,8.4c-.443.068-.487.342-.587.659a2.511,2.511,0,0,1-2.312,1.756A2.564,2.564,0,0,1,24.4,39.189,2.5,2.5,0,0,1,27.745,40.4c.258.606.523.677,1.115.554A14.406,14.406,0,0,0,39.315,32.9c.049-.1.081-.2.155-.391-1.007-.21-1-.966-.993-1.773.017-4.308.008-8.617.009-12.925,0-1.057.161-1.266,1.207-1.524-.051-.266-.087-.541-.157-.808a16.106,16.106,0,0,0-3.974-7.11c-.209-.22-.393-.661-.845-.272-.042.036-.318-.163-.459-.283a15.847,15.847,0,0,0-8.179-3.839A15.669,15.669,0,0,0,13.3,7.789a1.393,1.393,0,0,1-.838.217A15.412,15.412,0,0,0,7.81,16.249c1.348.423,1.348.423,1.348,1.845q0,6.463,0,12.925c0,1.138-.268,1.4-1.38,1.419-.627.009-1.24.046-1.6-.634-.055-.1-.306-.129-.469-.137-.373-.019-.748-.018-1.121,0-.612.027-.839-.314-.954-.862a1.157,1.157,0,0,0-.436-.693,6.711,6.711,0,0,1,.02-11.443,1.157,1.157,0,0,0,.425-.7.888.888,0,0,1,.849-.839.689.689,0,0,0,.488-.419A19.048,19.048,0,0,1,10.381,6.149a1.624,1.624,0,0,0,.137-.194",
    transform: "translate(0 0)",
    fill: "#007dba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25524",
    "data-name": "Path 25524",
    d: "M118.77,135.352a7.78,7.78,0,0,1-7.829-3.459l-.227.125.506,2.255a12.23,12.23,0,0,1-6.766-1.091,13.238,13.238,0,0,1-3.083-2.18,7.766,7.766,0,0,1,.709-12.018,11.7,11.7,0,0,1,10.76-2.064,10.679,10.679,0,0,1,6.057,4.055,7.326,7.326,0,0,1-.048,8.933,11.749,11.749,0,0,1-1.567,1.677.953.953,0,0,0-.3,1.325,17.055,17.055,0,0,0,1.352,1.74,3.45,3.45,0,0,0,.547.44l-.109.261m-4.274-8.6A1.519,1.519,0,0,0,116,125.184a1.57,1.57,0,0,0-1.576-1.521,1.637,1.637,0,0,0-1.554,1.408,1.571,1.571,0,0,0,1.622,1.678m-10.167,0a1.483,1.483,0,0,0,1.53-1.529,1.533,1.533,0,0,0-1.588-1.554,1.55,1.55,0,0,0-1.475,1.545,1.516,1.516,0,0,0,1.533,1.538m5.043-3.033a1.435,1.435,0,0,0-1.5,1.531,1.451,1.451,0,0,0,1.551,1.5,1.5,1.5,0,0,0,1.522-1.476,1.483,1.483,0,0,0-1.572-1.55",
    transform: "translate(-85.817 -101.078)",
    fill: "#2fa2d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25525",
    "data-name": "Path 25525",
    d: "M206.767,174.318a1.571,1.571,0,0,1-1.622-1.679,1.637,1.637,0,0,1,1.554-1.407,1.57,1.57,0,0,1,1.576,1.521,1.52,1.52,0,0,1-1.507,1.565",
    transform: "translate(-178.087 -148.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25526",
    "data-name": "Path 25526",
    d: "M130.268,174.342a1.516,1.516,0,0,1-1.533-1.538,1.55,1.55,0,0,1,1.475-1.545,1.533,1.533,0,0,1,1.588,1.554,1.483,1.483,0,0,1-1.53,1.529",
    transform: "translate(-111.755 -148.67)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25527",
    "data-name": "Path 25527",
    d: "M168.711,171.64a1.483,1.483,0,0,1,1.572,1.55,1.5,1.5,0,0,1-1.522,1.476,1.451,1.451,0,0,1-1.551-1.5,1.435,1.435,0,0,1,1.5-1.531",
    transform: "translate(-145.156 -149.001)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnOnDemand);
export default __webpack_public_path__ + "static/media/icn-On-Demand.83813e80c61edc22560333957751579c.svg";
export { ForwardRef as ReactComponent };